import React from "react";
import "../styles/Service.css";
import { Container } from "react-bootstrap";
import { FaMobileAlt,FaUndo,FaGlobe, FaRecycle, FaCogs, FaLink,FaDatabase } from "react-icons/fa";


const Service = () => {
  return (
    <>
      {/* Asset Recovery Services */}
      <section className="service-section service-bg1">
        <Container>
          <div className="service-container">
            <FaMobileAlt className="service-icon" /> {/* Large Icon on Left */}
            <div className="service-content">
              <h2 className="service-heading">ASSET RECOVERY SERVICES</h2>
              <p>
              Bhanot International LLC, physically receives all products into our monitored company-owned facilities. At Bhanot International, we help businesses turn surplus and end-of-life assets into revenue. Whether you're a manufacturer, retailer, network operator, or dealer, our expert team ensures you get the best returns on unused inventory. We handle surplus, refurbished, and outdated products with a smart, responsible, and efficient approach. Through our global network, we find the right buyers, helping you recover maximum value while keeping operations smooth and hassle-free.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* Reverse Logistics */}
      <section className="service-section service-bg2">
        <Container>
          <div className="service-container">
            <FaUndo className="service-icon" />
            <div className="service-content">
              <h2 className="service-heading">REVERSE LOGISTICS</h2>
              <p>
              Through product disassembly, part reuse, and remarketing, we extend the lifespan. At LLC, we specialize in safe and thorough data removal from consumer electronics, including cell phones, tablets, computers, and memory cards. Our services are conducted in a high-security, state-of-the-art facility with restricted access and 24/7 CCTV monitoring. Our dedication to operational excellence has earned us prestigious certifications, including ISO 14001:2015, ISO 45001:2018, ISO 9001:2015, and R2v3. You can trust us to handle data removal with the highest standards of security, efficiency, and compliance.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* Recycling */}
      <section className="service-section service-bg3">
        <Container>
          <div className="service-container">
            <FaGlobe className="service-icon" />
            <div className="service-content">
              <h2 className="service-heading">DISTRIBUTION SERVICES</h2>
              <p>
              Through product disassembly, part reuse, and remarketing, we extend the lifespan. We connect you with the right products to meet demand, maximize profits, and drive growth. Our strong global partnerships and industry expertise allow us to source new, refurbished, and end-of-life wireless phones, accessories, and tablets, ensuring you always have the inventory you need.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* RECycling */}
      <section className="service-section service-bg4">
        <Container>
          <div className="service-container">
            <FaRecycle className="service-icon" />
            <div className="service-content">
              <h2 className="service-heading">RECYCLING</h2>
              <p>
              Our recycling services help you extract the maximum value from irreparable devices through a variety of industry-leading methods.
              <ul>
              <li>Certificate Of Destruction – Secure removal of sensitive information.</li>
              <li>E-Waste Recycling – Proper disposal of electronic components.</li>
              <li>Plastic Recycling – Repurposing plastic materials to reduce waste.</li>
              <li>Circuit Board Reclamation – Recovering valuable metals and components.</li>
              <li>Universal Waste Recycling – Batteries – Safe disposal of hazardous materials.</li>
              <li>Paper Recycling – Protecting sensitive information while reducing waste.</li>
              <li>Please responsibly recycle electronics at the end of their life.</li>
              </ul>
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* Supply Chain Fulfillment */}
      <section className="service-section service-bg5">
        <Container>
          <div className="service-container">
            <FaLink className="service-icon" />
            <div className="service-content">
              <h2 className="service-heading">SUPPLY CHAIN FULFILLMENT</h2>
              <p>
              Our refined process ensures maximum efficiency and sustainability.Our supply chain is one of the most reliable in the industry, backed by over a decade of experience in delivering the right products to businesses worldwide. We ensure fast, seamless, and efficient fulfillment, helping you reach the market quicker, reduce risks, and maximize profitability.With our robust supply chain solutions, you can seize opportunities and scale your business effortlessly. We specialize in sourcing high-demand phones, accessories, and tablets, ensuring you always have what your customers need. Unlike many competitors, we only sell what we physically stock in our company-owned warehouse eliminating delays and uncertainty.
              </p>
            </div>
          </div>
        </Container>
      </section>

    {/* Process Services */}
    <section className="service-section service-bg6">
    <Container>
        <div className="service-container">
        <FaCogs className="service-icon" />
        <div className="service-content">
            <h2 className="service-heading">PROCESS SERVICES</h2>
            <p>
            Our streamlined process ensures maximum efficiency and sustainability. We implement 
            cutting-edge methodologies to optimize every step, ensuring accuracy, quality, 
            and compliance at all levels. 
            </p>
            <ul>
            <li><strong>Inspection & Grading:</strong> Each device undergoes a meticulous inspection to assess its condition, functionality, and resale value.</li>
            <li><strong>Data Sanitization:</strong> We follow industry-leading data erasure techniques to ensure complete removal of sensitive information.</li>
            <li><strong>Repair & Refurbishment:</strong> Devices are restored to peak performance using certified parts and professional repair techniques.</li>
            <li><strong>Inventory Management:</strong> Advanced tracking ensures efficient organization and accessibility of stock.</li>
            <li><strong>Distribution & Logistics:</strong> Our global distribution network ensures timely and cost-effective delivery.</li>
            <li><strong>Compliance & Certifications:</strong> We adhere to the highest industry standards, including R2v3, ISO 14001, and ISO 9001.</li>
            </ul>
            <p>
            By integrating advanced technology and expert processes, we help businesses maximize 
            efficiency, reduce costs, and enhance overall operational effectiveness.
            </p>
        </div>
        </div>
    </Container>
    </section>

    {/* Data Sanitization */}
    <section className="service-section service-bg7">
    <Container>
        <div className="service-container">
        <FaDatabase className="service-icon" />
        <div className="service-content">
            <h2 className="service-heading">DATA SANITIZATION</h2>
            <p>
            We specialize in secure data sanitization, purging, and destruction of storage devices 
            to protect sensitive information. Our services ensure compliance with industry standards 
            such as NISPOM and other accepted guidelines.
            </p>
            <ul>
            <li><strong>Certified Data Destruction:</strong> Secure handling of end-of-life storage devices.</li>
            <li><strong>Compliance & Security:</strong> Adheres to strict security protocols, including monitoring and chain-of-custody procedures.</li>
            <li><strong>Independent Validation:</strong> Regular third-party audits ensure effectiveness and compliance.</li>
            <li><strong>Records Management:</strong> Maintains detailed logs of all data sanitization processes.</li>
            <li><strong>Secure Transport & Processing:</strong> Data-containing devices are tracked and secured during transit.</li>
            </ul>
            <p>
            Our expert team follows rigorous protocols to guarantee data is permanently removed, 
            providing clients with peace of mind in handling sensitive information.
            </p>
        </div>
        </div>
    </Container>
    </section>


    </>
  );
};

export default Service;